import axios from "axios"
import { myAxios } from "./axios"

export function getRooms(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})
        },
    }
    return myAxios.get("/rooms", config)
}

export function getRoom(id) {
    return myAxios.get("/rooms/" + id)
}

export function addRoom(data) {
    return myAxios.post("/rooms/create", data)
}

export function editRoom(id, data) {
    return myAxios.put("/rooms/" + id + "/update", data)
}

export function deleteRoom(id) {
    return myAxios.delete("/rooms/" + id + "/delete")
}


export function getRoomRenters(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})
        },
    }
    return myAxios.get(`/rooms/${data.roomId}/renters`, config)
}
